/* global google */

let seminarLogPrefix = '[SEMINAR] ';

window.initMap = () => {
  console.debug(seminarLogPrefix + 'Initializing google maps API + ZIP autocomplete');
  //gmaps autocomplete
  let txtZip = document.getElementById('txtZip');
  let options = {
    componentRestrictions: { country: 'de' },
    strictBounds: true,
    types: ['(regions)'],
  };
  new google.maps.places.Autocomplete(txtZip, options);
};

window.initSeminarList = () => {
  let txtZip = document.getElementById('txtZip');
  let btnCoords = document.getElementById('btnCoords');
  let lat = document.getElementById('lat');
  let lon = document.getElementById('lon');
  let seminarList = document.getElementById('seminar-list');
  let seminar = document.getElementById('seminar');
  let loadingDiv = document.getElementById('loading-indicator');

  const Http = new XMLHttpRequest();

  function getEventListURL() {
    let getParams = '';
    if (lat.value) {
      getParams = getParams + 'lat=' + encodeURIComponent(lat.value);
    }
    if (lon.value) {
      getParams = getParams + '&lon=' + encodeURIComponent(lon.value);
    }
    if (getParams.length > 0) {
      getParams = '?' + getParams;
    }
    let url = seminar.value
      ? '/de-de/campus/seminare/' +
        encodeURIComponent(JSON.parse('"' + seminar.value + '"')) +
        '/event-list' +
        getParams
      : '/de-de/campus/seminar-event-list' + getParams;
    return url;
  }

  function showLoadingIndicator() {
    loadingDiv.setAttribute('style', 'display:block');
  }
  function hideLoadingIndicator() {
    loadingDiv.setAttribute('style', 'display:none');
  }

  txtZip.addEventListener('change', function () {
    if (txtZip.value.length === 0) {
      lat.value = '';
      lon.value = '';
    }
  });

  seminar.addEventListener('change', function () {
    const Http = new XMLHttpRequest();
    if (seminar.value) {
      showLoadingIndicator();
      const url = getEventListURL();

      console.debug(seminarLogPrefix + 'Requesting new seminar list after seminar selection', url);
      Http.open('POST', url);
      Http.send();

      Http.onreadystatechange = () => {
        console.debug(seminarLogPrefix + 'Received http response(after seminar selection)', Http);
        seminarList.innerHTML = Http.responseText;
        hideLoadingIndicator();
      };
    }
  });

  let url = getEventListURL();
  console.debug(seminarLogPrefix + 'Sending initial seminar list request', url);
  seminarList.innerHTML = '';
  showLoadingIndicator();
  Http.open('GET', url);
  Http.send();

  Http.onreadystatechange = () => {
    console.debug(seminarLogPrefix + 'Received http response', Http);
    hideLoadingIndicator();
    seminarList.innerHTML = Http.responseText;
  };

  txtZip.addEventListener('focusout', function () {
    seminarList.innerHTML = '';
    console.debug(seminarLogPrefix + 'Focusout on ZIP field', txtZip.value);
    let geocoder = new google.maps.Geocoder();
    console.debug(seminarLogPrefix + 'Getting cooridnates for ZIP', txtZip.value);
    showLoadingIndicator();
    geocoder.geocode({ address: txtZip.value }, function (results, status) {
      console.debug(seminarLogPrefix + 'Received geocode status', status, 'expecting', google.maps.GeocoderStatus.OK);
      if (!status) {
        console.debug(seminarLogPrefix + 'geo result not found', results[0]);
        lat.value = null;
        lon.value = null;
      } else if (status == google.maps.GeocoderStatus.OK) {
        console.debug(seminarLogPrefix + 'First geo result', results[0]);
        lat.value = new Number(results[0].geometry.location.lat());
        lon.value = new Number(results[0].geometry.location.lng());
      }

      const Http = new XMLHttpRequest();
      const url = getEventListURL();
      console.debug(seminarLogPrefix + 'Requesting new seminar list sorted by distance', url);
      Http.open('POST', url);
      Http.send();

      Http.onreadystatechange = () => {
        console.debug(seminarLogPrefix + 'Received http response(sorted)', Http);
        seminarList.innerHTML = Http.responseText;
        hideLoadingIndicator();
      };
    });
  });

  // called when Ajax.BeginForm finishes
  window.OnEventsLoaded = function () {
    if (window.filterList) {
      window.filterList();
    }
  };

  btnCoords.addEventListener('click', function (e) {
    /*if (txtZip.value.length > 0) {
            // just send the data
            return true;
        }*/
    if (!navigator.geolocation || !navigator.geolocation.getCurrentPosition) {
      console.error(seminarLogPrefix + 'Geolocation is not available');
      e.preventDefault();
      return false;
    }
    console.log(seminarLogPrefix + 'Getting geo position');
    showLoadingIndicator();
    navigator.geolocation.getCurrentPosition(function (position) {
      console.log(seminarLogPrefix + 'Got geo position', position);

      let lati = position.coords['latitude'];
      let lng = position.coords['longitude'];
      let geocoder = new google.maps.Geocoder();
      let request = {
        location: { lat: lati, lng: lng },
      };
      geocoder.geocode(request, function (result, status) {
        if (status !== 'OK') {
          console.error(seminarLogPrefix + 'Failed to geocode.', status);
          return;
        }
        if (result != null && result.length > 0) {
          for (let i = 0; i < result.length; i++) {
            console.log(seminarLogPrefix + 'checking result', result, i);
            if (result[i]['types'][0] === 'postal_code') {
              console.log(seminarLogPrefix + 'found zip result', result[i]);
              let address = result[i]['formatted_address'];
              txtZip.value = address;
              lat.value = position.coords['latitude'];
              lon.value = position.coords['longitude'];

              const Http = new XMLHttpRequest();
              const url = getEventListURL();
              console.log(seminarLogPrefix + 'requesting seminar list, sorted by distance', url);
              Http.open('POST', url);
              Http.send();

              Http.onreadystatechange = () => {
                hideLoadingIndicator();
                console.log(seminarLogPrefix + 'Got http response (sorted by dinstance, by geolocation)');
                seminarList.innerHTML = Http.responseText;
              };
              break;
            }
          }
        }
      });
    });

    console.log(seminarLogPrefix + 'Returning from geolocation button handler');
    e.preventDefault ? e.preventDefault() : (e.returnValue = false);

    return false;
  });
};
